import type { ReactNode } from 'react'
import { Container } from '../ui/Container'

type PageHeroProps = {
  eyebrow?: string
  title: string
  description?: string
  children?: ReactNode
}

/** Standard top-of-page block for every route that is not the homepage. */
export const PageHero = ({ eyebrow, title, description, children }: PageHeroProps) => (
  <section className="border-b border-border bg-muted/40">
    <Container className="enter py-12 lg:py-16">
      {eyebrow ? <p className="type-overline text-info-subtle-foreground">{eyebrow}</p> : null}
      <h1 className="mt-2 max-w-3xl type-h1 text-foreground">{title}</h1>
      {description ? (
        <p className="mt-4 max-w-2xl type-body-lg text-muted-foreground">{description}</p>
      ) : null}
      {children ? <div className="mt-8">{children}</div> : null}
    </Container>
  </section>
)
